var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import md5 from "md5";
import { useState } from "react";
import http from "./http";
import { setAuthCookie } from "./session";
const formatSource = (values) => {
    const body = new FormData();
    body.append("user_name", values.email.trim());
    body.append("password", md5(values.password));
    body.append("source", values.source);
    return body;
};
/**
 * 判断用户是否需要补充信息
 * @param token 用户 token
 * @param locale 当前语言
 * @returns 是否需要补充信息
 */
export const fetchNecessary = (token, locale) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const response = yield http.get(`/usercenter/en/necessary_to_complete?auth_token=${token}`, {
            showOriginResponse: true,
            getLang: () => locale,
        });
        if ((response === null || response === void 0 ? void 0 : response.code) === 0) {
            return (_a = response.data) === null || _a === void 0 ? void 0 : _a.is_necessary;
        }
        throw new Error(response === null || response === void 0 ? void 0 : response.msg);
    }
    catch (errorInfo) {
        const msg = typeof errorInfo === "string" ? errorInfo : errorInfo.message;
        throw new Error(msg || "unknown error");
    }
});
const login = (_a) => __awaiter(void 0, [_a], void 0, function* ({ config, values, profileCompleteUrl, onSuccess, onError }) {
    try {
        const body = formatSource(values);
        body.append("language", values.locale);
        body.append("source_link", document.referrer || "/");
        body.append("referrer", window.location.href || "");
        body.append("user_agent", navigator.userAgent || "");
        const response = yield http.post(`/usercenter/english/v1/auth`, {
            body,
            showOriginResponse: true,
            getLang: () => values.locale,
        });
        if ((response === null || response === void 0 ? void 0 : response.code) === 0) {
            const { token } = response.data;
            const isNecessary = yield fetchNecessary(token, values.locale);
            if (isNecessary) {
                setAuthCookie(config, token, { temporary: true });
                window.location.href = profileCompleteUrl;
            }
            else {
                if (values.remember) {
                    // 设置持久化 cookie，60 天有效期，使用客户端方法来设置cookie是为了避免在登录成功设置cookie后，触发依赖cookie的服务端组件重执行
                    setAuthCookie(config, token, { remember: true });
                    // await setPersistentCookie(COOKIE_DEFAULT_KEY, token, 60 * 24 * 60 * 60, ".metal.com")
                }
                else {
                    // 设置 session cookie（不设置过期时间），使用客户端方法来设置cookie是为了避免在登录成功设置cookie后，触发依赖cookie的服务端组件重执行
                    setAuthCookie(config, token);
                    // await setSessionCookie(COOKIE_DEFAULT_KEY, token, ".metal.com")
                }
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
            }
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError(response);
        }
    }
    catch (errorInfo) {
        const msg = typeof errorInfo === "string" ? errorInfo : errorInfo.message;
        onError === null || onError === void 0 ? void 0 : onError({ msg: msg || "unknown error" });
    }
});
const register = (_a) => __awaiter(void 0, [_a], void 0, function* ({ values, onSuccess, onError }) {
    try {
        const body = formatSource(values);
        body.append("verify_code", values.verifyCode.trim());
        body.append("referrer", window.location.href || "");
        body.append("user_agent", navigator.userAgent || "");
        const response = yield http.post(`/usercenter/english/v1/register`, {
            body,
            showOriginResponse: true,
            getLang: () => values.locale,
        });
        if ((response === null || response === void 0 ? void 0 : response.code) === 0) {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError((response === null || response === void 0 ? void 0 : response.msg) || "unknown error");
        }
    }
    catch (errorInfo) {
        const msg = typeof errorInfo === "string" ? errorInfo : errorInfo.message;
        onError === null || onError === void 0 ? void 0 : onError(msg || "unknown error");
    }
});
const resetPassword = (_a) => __awaiter(void 0, [_a], void 0, function* ({ values, onSuccess, onError }) {
    try {
        const formData = formatSource(values);
        formData.append("verify_code", values.verifyCode.trim());
        formData.append("language", values.locale);
        const response = yield http.post(`/usercenter/english/v1/reset_password`, {
            body: formData,
            showOriginResponse: true,
            getLang: () => values.locale,
        });
        if ((response === null || response === void 0 ? void 0 : response.code) === 0) {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError((response === null || response === void 0 ? void 0 : response.msg) || "unknown error");
        }
    }
    catch (errorInfo) {
        const msg = typeof errorInfo === "string" ? errorInfo : errorInfo.message;
        onError === null || onError === void 0 ? void 0 : onError(msg || "unknown error");
    }
});
export const useLogin = () => {
    const [loading, setLoading] = useState(false);
    const run = (params) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield login(params);
        }
        finally {
            setLoading(false);
        }
    });
    return [loading, run];
};
export const useRegister = () => {
    const [loading, setLoading] = useState(false);
    const run = (params) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield register(params);
        }
        finally {
            setLoading(false);
        }
    });
    return [loading, run];
};
export const useResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const run = (params) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield resetPassword(params);
        }
        finally {
            setLoading(false);
        }
    });
    return [loading, run];
};
//# sourceMappingURL=auth.js.map